import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '../Avatar/Avatar';
import { Stack } from '../server/layout/Stack/index';
import { Row } from '../server/layout/Row/index';
import { Body } from '../server/typography/Body/index';
const NAME_FONT_FOR = {
    32: 'var(--type-body)',
    36: 'var(--type-body)',
    44: 'var(--type-label)',
};
export function PersonRow({ photo, name, sublabel, avatarSize = 36, avatarSlot, nameFont: nameFontOverride, nameColor = 'foreground', meta, body, right, gap = 'md', align = 'center', href, linkAs, }) {
    const nameFont = nameFontOverride ?? NAME_FONT_FOR[avatarSize];
    const LinkAs = (linkAs ?? 'a');
    const linkStyle = { color: 'inherit', textDecoration: 'none' };
    const avatar = avatarSlot ?? _jsx(Avatar, { src: photo, name: name, size: avatarSize });
    const wrappedAvatar = href ? (_jsx(LinkAs, { href: href, style: { ...linkStyle, display: 'inline-flex', flexShrink: 0 }, "aria-hidden": true, tabIndex: -1, children: avatar })) : (_jsx("span", { style: { flexShrink: 0 }, children: avatar }));
    // Apply name typography directly to the rendered element so the link wrapper
    // doesn't introduce its own strut. A nested `<a><span>` flex child would
    // blockify the anchor and clamp to inherited line-height (~1.5), producing
    // extra leading below the name.
    const nameStyle = {
        margin: 0,
        font: nameFont,
        ...(nameColor === 'mute' ? { color: 'var(--muted-foreground)' } : {}),
    };
    const wrappedName = href ? (_jsx(LinkAs, { href: href, style: { ...linkStyle, ...nameStyle, alignSelf: 'flex-start' }, children: name })) : (_jsx("span", { style: nameStyle, children: name }));
    return (_jsxs(Row, { gap: gap, align: align, style: { minWidth: 0 }, children: [wrappedAvatar, _jsxs(Stack, { style: { flex: 1, minWidth: 0, rowGap: 2 }, children: [wrappedName, sublabel && _jsx(Body, { size: "sm", color: "mute", as: "span", truncate: true, children: sublabel }), meta, body] }), right] }));
}
//# sourceMappingURL=PersonRow.js.map